import { useAuthExperience } from "../../features/auth/hooks/useAuthExperience";
import { openUrlInCurrentTab } from "../../utils/securityUtils";

const ContactCard = () => {
  const authExperience = useAuthExperience();

  return (
    <div className="d-flex flex-wrap">
      <div>
        <p>If you have any questions, concerns, or feedback, please don't hesitate to reach out to us. We're here to help and would love to hear from you!</p>
      </div>
      <div><strong>Company Name: </strong>{authExperience.company.companyName}</div>
      <div><strong>Registered State: </strong>{authExperience.company.registeredState}</div>
      <div><strong>Email: </strong>
        <a onClick={(e) => {
          e.preventDefault();
          openUrlInCurrentTab(`mailto:${authExperience.company.supportEmail}`);
        }}>{authExperience.company.supportEmail}</a>
      </div>
      <div><strong>Phone: </strong>
        <a onClick={(e) => {
          e.preventDefault();
          openUrlInCurrentTab(`tel:${authExperience.company.supportPhone}`);
        }}>{authExperience.company.supportPhone}</a>
      </div>
      <div>
        <p>Our support team is available <strong>{authExperience.company.supportHours}</strong>. We strive to respond to all inquiries within 24 hours.</p>
      </div>
      <p className="justify-content-center align-items-center d-flex mt-4">Thank you for using our services. We look forward to assisting you!</p>
    </div>

  );
};

export default ContactCard;
